export const range = (min, max) => {
  const list = [];
  for (let i = min; i <= max; i++) list.push(i);
  return list;
};
